<template>
  <v-layout row wrap align-content-start fill-height class="pa-4 admin-page">
    <v-flex xs12 class="page-head-container mb-3">
      <v-flex xs12 class="mb-4 page-head-container">
        <h1 class="headline font-weight-light">{{ $t('inspection_instrument.list') }}</h1>
      </v-flex>

      <v-flex xs12 class="search-container">
        <v-text-field
          :label="$t('common.search')"
          solo
          flat
          hide-details
          v-model="search"
        ></v-text-field>
      </v-flex>

      <v-flex xs12>
        <template>
          <v-data-table
            v-if="getInspectionInstruments.length > 0"
            :headers="headers"
            :items="getInspectionInstruments"
            :pagination.sync="pagination"
            :search="search"
            hide-actions
            class="my-4"
            :disable-initial-sort=true >


            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  id="inspection_instrument"
                  v-for="header in headers"
                  :key="header.text"
                  :class="['column sortable', pagination.order ? 'desc' : 'asc', header.value === pagination.title ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="props">
              <tr @click="clickItem(props.item)">
                <td>
                  <v-edit-dialog
                    :return-value.sync="props.item.inspection_instrument"
                    lazy
                    @save="updateInspectionInstrument(props.item.id, 'inspection_instrument', tempItem.inspection_instrument)"
                  > {{ props.item.inspection_instrument }}
                    <v-text-field
                      slot="input"
                      v-model="tempItem.inspection_instrument"
                      :label="$t('inspection_instrument.edit')"
                      single-line
                    ></v-text-field>
                  </v-edit-dialog>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
      </v-flex>
    </v-flex>

    <v-btn icon fixed bottom right fab color="primary" @click="addInspectionInstrument">
      <v-icon>add</v-icon>
    </v-btn>

    <v-snackbar
      v-model="snackbar"
      bottom
      :timeout="timeout"
      color="green"
    >
      {{ $t('inspection_instrument.added') }}
    </v-snackbar>
  </v-layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'AdminInspectionInstrumentList',
    data() {
      return {
        search: '',
        pagination: {
          rowsPerPage: -1,
          title:'',
          order:false
        },
        headers: [
          {
            text: this.$t('inspection_instrument.title'),
            align: 'left',
            value: 'inspection_instrument',
            // sortable: false
          }
        ],
        snackbar: false,
        timeout: 3000,
        tempItem:'',
        tempValue:''
      }
    },

    computed: {
      ...mapGetters('inspectionInstruments', [
        'getInspectionInstruments'
      ])
    },

    created () {
      this.fetchInspectionInstruments()
    },

    methods: {
      ...mapActions('inspectionInstruments', [
        'fetchInspectionInstruments'
      ]),
      changeSort (column) {
        if(column===''){return;}
        if (this.pagination.title === column) {
          this.pagination.order = !this.pagination.order
        } else {
          this.pagination.title = column
          this.pagination.order = false
        }
        this.$store.dispatch('inspectionInstruments/sortInspectionInstrument', {title:column,order:this.pagination.order})

      },

      updateInspectionInstrument ( inspectionInstrumentID, field, value ) {
        // console.log(inspectionInstrumentID,field,value)
        const updateObj = {
          inspectionInstrumentID: inspectionInstrumentID,
          field: field,
          value: value
        }
        
        this.$store.dispatch('inspectionInstruments/updateColumnById', updateObj)
      },

      async addInspectionInstrument () {
        try {
          await this.$store.dispatch('inspectionInstruments/addInspectionInstrument')
          this.snackbar = true
        } catch (e) {
          this.snackbar = false
        }
      },
      clickItem(data){
        this.tempItem = Object.assign({}, data);
      }
    }
  }
</script>

<style lang="scss">
</style>